// extracted by mini-css-extract-plugin
export default {"installAppContainer":"InstallApp_installAppContainer__qCv1Q","message":"InstallApp_message__bFbM8","buttonBlock":"InstallApp_buttonBlock__9JVqX"};